import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CallbackPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    console.log('CallbackPage - Current URL:', window.location.href);

    // Parse query string parameters
    const queryParams = new URLSearchParams(window.location.search);

    // Extract parameters
    const accessToken = queryParams.get('access_token');
    const instanceUrl = queryParams.get('instance_url');
    const state = queryParams.get('state');

    console.log('CallbackPage - Extracted Access Token:', accessToken);
    console.log('CallbackPage - Extracted Instance URL:', instanceUrl);
    console.log('CallbackPage - Extracted State:', state);

    let redirect = '/'; // Default redirect
    if (state) {
      try {
        const parsedState = JSON.parse(decodeURIComponent(state));
        redirect = parsedState.redirect || '/';
      } catch (error) {
        console.error('Failed to parse state:', error);
      }
    }

    console.log('CallbackPage - Final Redirect:', redirect);
    console.log('CallbackPage - Storing in sessionStorage:');
    console.log('access_token:', accessToken);
    console.log('instance_url:', instanceUrl);
    if (accessToken) {
      console.log('CallbackPage - Storing token in sessionStorage');
    
      // Store token
      sessionStorage.setItem('access_token', accessToken);
      localStorage.setItem('access_token', accessToken); // Backup in case sessionStorage is lost
    
      sessionStorage.setItem('instance_url', instanceUrl);
      localStorage.setItem('instance_url', instanceUrl);
    
      console.log('CallbackPage - Token stored successfully in sessionStorage.');
    
      // Dispatch event to notify app about auth update
      window.dispatchEvent(new Event('auth-updated'));
    
      console.log('CallbackPage - Navigating to:', redirect);
    
      // ✅ **Delay navigation slightly to allow sessionStorage update**
      setTimeout(() => {
        navigate(redirect, { replace: true });
    
        // ✅ **Optional: Force a refresh to ensure `App.js` detects authentication**
        setTimeout(() => {
          window.location.reload();
        }, 100);
      }, 50);
    } else {
      console.error('CallbackPage - Access token not found.');
      alert('Error logging in. Please try again.');
      navigate('/'); // Redirect to home or login page
    }
  }, [navigate]);

  return (
    <div>
      <h1>Processing Login...</h1>
      <p>Please wait while we validate your login.</p>
    </div>
  );
};

export default CallbackPage;